module.exports = "/packs/media/images/logo-edwardjones-30107ee961e901a22deaceaa959475e5.png";